/**
 * 客服系统
 */

export default {
  path: '/app-jump',
  name: 'app-jump',
  meta: {
    title: '授权跳转',
    auth: true
  },
  component: () => import('@/conf/home/pages/jump'),
  children: [
    {
      path: '/app-jump/call-back',
      name: 'app-jump',
      meta: {
        title: '小程序授权跳转',
        auth: true
      },
      component: () => import('@/conf/home/pages/jump/wxCallBack')
    },
    {
      path: '/app-jump/author-health',
      name: 'author-health',
      meta: {
        title: '存健康授权中',
        auth: true
      },
      component: () => import('@/conf/home/pages/jump/authorHealth')
    }, {
      path: '/app-jump/ewx-login',
      name: 'author-hdsec',
      meta: {
        title: '企业微信扫码登录',
        auth: true
      },
      component: () => import('@/conf/home/pages/jump/scanCodeLogin')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/js/conf/home/router/jump.js